import { defineStore } from 'pinia'
import { ref } from 'vue'

export type MessageType = 'success' | 'used' | 'not-found'

export interface Message {
    type: MessageType
    message: string
    extra?: string
    ticketsetId?: number | string
    code?: string
    sent?: boolean
}

export const useMessagesStore = defineStore('messages', () => {
    const messages = ref<Message[]>([])

    function addMessage(message: Message) {
        messages.value = [message, ...messages.value].slice(0, 50)
    }

    function clearMessages() {
        messages.value = []
    }

    function markSent(code: string, ticketsetId: number | string) {
        messages.value = messages.value.map(m =>
            m.code === code && m.ticketsetId === ticketsetId && m.type === 'success' ? { ...m, sent: true } : m
        )
    }

    return { messages, addMessage, clearMessages, markSent }
})
